import * as React from 'react';
import type { StudyPageNavigationViewModel } from '../../../ViewModel/StudyPageNavigation/StudyPageNavigationViewModel.csharp';
import { Navigation } from '~/Features/StudyPage/Campus/Partials/Navigation/Navigation';

export const StudyPageNavigation: React.FC<StudyPageNavigationViewModel> = props => {
    const { sections, translations } = props;
    const { navigationLabel, apply, home } = translations;

    const sectionAnchors = sections.map(section => ({ id: section.id, label: section.label }));

    return (
        <Navigation
            sectionAnchors={sectionAnchors}
            translations={{
                label: navigationLabel,
                home,
                apply,
            }}
        />
    );
};
